export const COUNTRY_MAP: { [key: string]: string } = {
    "AD": "Andorra", "AE": "United Arab Emirates", "AF": "Afghanistan", "AG": "Antigua and Barbuda", "AL": "Albania", "AM": "Armenia", "AO": "Angola", "AQ": "Antarctica", "AR": "Argentina", "AT": "Austria", "AU": "Australia", "AW": "Aruba", "AZ": "Azerbaijan", "BA": "Bosnia and Herzegovina", "BB": "Barbados", "BD": "Bangladesh", "BE": "Belgium", "BF": "Burkina Faso", "BG": "Bulgaria", "BH": "Bahrain", "BJ": "Benin", "BM": "Bermuda", "BN": "Brunei", "BO": "Bolivia", "BQ": "Bonaire", "BR": "Brazil", "BS": "Bahamas", "BT": "Bhutan", "BW": "Botswana", "BY": "Belarus", "BZ": "Belize", "CA": "Canada", "CD": "Democratic Republic of the Congo", "CG": "Republic of the Congo", "CH": "Switzerland", "CI": "Ivory Coast", "CL": "Chile", "CM": "Cameroon", "CN": "China", "CO": "Colombia", "CR": "Costa Rica", "CU": "Cuba", "CV": "Cape Verde", "CW": "Curacao", "CY": "Cyprus", "CZ": "Czech Republic", "DE": "Germany", "DJ": "Djibouti", "DK": "Denmark", "DO": "Dominican Republic", "DZ": "Algeria", "EC": "Ecuador", "EE": "Estonia", "EG": "Egypt", "ES": "Spain", "ET": "Ethiopia", "FI": "Finland", "FJ": "Fiji", "FO": "Faroe Islands", "FR": "France", "GA": "Gabon", "GB": "United Kingdom", "GD": "Grenada", "GE": "Georgia", "GF": "French Guiana", "GG": "Guernsey", "GH": "Ghana", "GL": "Greenland", "GM": "Gambia", "GP": "Guadeloupe", "GQ": "Equatorial Guinea", "GR": "Greece", "GT": "Guatemala", "GU": "Guam", "GY": "Guyana", "HK": "Hong Kong", "HN": "Honduras", "HR": "Croatia", "HT": "Haiti", "HU": "Hungary", "ID": "Indonesia", "IE": "Ireland", "IL": "Israel", "IN": "India", "IQ": "Iraq", "IS": "Iceland", "IT": "Italy", "JE": "Jersey", "JM": "Jamaica", "JO": "Jordan", "JP": "Japan", "KE": "Kenya", "KG": "Kyrgyzstan", "KH": "Cambodia", "KM": "Comoros", "KN": "Saint Kitts and Nevis", "KR": "South Korea", "KW": "Kuwait", "KY": "Cayman Islands", "KZ": "Kazakhstan", "LA": "Laos", "LB": "Lebanon", "LC": "Saint Lucia", "LI": "Liechtenstein", "LK": "Sri Lanka", "LR": "Liberia", "LS": "Lesotho", "LT": "Lithuania", "LU": "Luxembourg", "LV": "Latvia", "LY": "Libya", "MA": "Morocco", "MC": "Monaco", "MD": "Moldova", "ME": "Montenegro", "MG": "Madagascar", "MK": "North Macedonia", "ML": "Mali", "MM": "Myanmar (Burma)", "MN": "Mongolia", "MO": "Macao", "MP": "Northern Mariana Islands", "MQ": "Martinique", "MR": "Mauritania", "MT": "Malta", "MU": "Mauritius", "MV": "Maldives", "MX": "Mexico", "MY": "Malaysia", "MZ": "Mozambique", "NA": "Namibia", "NC": "New Caledonia", "NE": "Niger", "NG": "Nigeria", "NI": "Nicaragua", "NL": "Netherlands", "NO": "Norway", "NP": "Nepal", "NZ": "New Zealand", "OM": "Oman", "PA": "Panama", "PE": "Peru", "PF": "French Polynesia", "PG": "Papua New Guinea", "PH": "Philippines", "PK": "Pakistan", "PL": "Poland", "PR": "Puerto Rico", "PS": "Palestine", "PT": "Portugal", "PY": "Paraguay", "QA": "Qatar", "RE": "Reunion", "RO": "Romania", "RS": "Serbia", "RU": "Russia", "RW": "Rwanda", "SA": "Saudi Arabia", "SE": "Sweden", "SG": "Singapore", "SI": "Slovenia", "SK": "Slovakia", "SL": "Sierra Leone", "SM": "San Marino", "SN": "Senegal", "SO": "Somalia", "SR": "Suriname", "SV": "El Salvador", "SX": "Sint Maarten", "SY": "Syria", "SZ": "Eswatini", "TG": "Togo", "TH": "Thailand", "TJ": "Tajikistan", "TL": "East Timor", "TN": "Tunisia", "TR": "Turkey", "TT": "Trinidad and Tobago", "TW": "Taiwan", "TZ": "Tanzania", "UA": "Ukraine", "UG": "Uganda", "US": "United States", "UY": "Uruguay", "UZ": "Uzbekistan", "VC": "Saint Vincent and the Grenadines", "VE": "Venezuela", "VI": "U.S. Virgin Islands", "VN": "Vietnam", "XK": "Kosovo", "YE": "Yemen", "YT": "Mayotte", "ZA": "South Africa", "ZM": "Zambia", "ZW": "Zimbabwe"
};

export const COUNTRIES_LIST = Object.entries(COUNTRY_MAP).map(([code, name]) => ({ code, name }));



export const ALL_LANGUAGES = [
    "Afrikaans", "Albanian", "Amharic", "Arabic", "Armenian", "Azerbaijani", "Basque", "Belarusian", "Bengali", "Bosnian", "Bulgarian", "Catalan", "Cebuano", "Chichewa", "Chinese (Simplified)", "Chinese (Traditional)", "Corsican", "Croatian", "Czech", "Danish", "Dutch", "English (US)", "English (UK)", "Esperanto", "Estonian", "Filipino", "Finnish", "French", "Frisian", "Galician", "Georgian", "German", "Greek", "Gujarati", "Haitian Creole", "Hausa", "Hawaiian", "Hebrew", "Hindi", "Hmong", "Hungarian", "Icelandic", "Igbo", "Indonesian", "Irish", "Italian", "Japanese", "Javanese", "Kannada", "Kazakh", "Khmer", "Kinyarwanda", "Korean", "Kurdish (Kurmanji)", "Kyrgyz", "Lao", "Latin", "Latvian", "Lithuanian", "Luxembourgish", "Macedonian", "Malagasy", "Malay", "Malayalam", "Maltese", "Maori", "Marathi", "Mongolian", "Myanmar (Burmese)", "Nepali", "Norwegian", "Odia (Oriya)", "Pashto", "Persian", "Polish", "Portuguese", "Punjabi", "Romanian", "Russian", "Samoan", "Scots Gaelic", "Serbian", "Sesotho", "Shona", "Sindhi", "Sinhala", "Slovak", "Slovenian", "Somali", "Spanish", "Sundanese", "Swahili", "Swedish", "Tajik", "Tamil", "Tatar", "Telugu", "Thai", "Turkish", "Turkmen", "Ukrainian", "Urdu", "Uyghur", "Uzbek", "Vietnamese", "Welsh", "Xhosa", "Yiddish", "Yoruba", "Zulu"
];

export const TRAFFIC_SOURCES = [
    { value: "Direct", label: "Direct" },
    { value: "Organic (General)", label: "Organic (General)" },
    { value: "Organic, Google Search", label: "Organic - Google Search" },
    { value: "Organic, Google News", label: "Organic - Google News" },
    { value: "Organic, Google Images", label: "Organic - Google Images" },
    { value: "Organic, Google Video", label: "Organic - Google Video" },
    { value: "Organic, Bing", label: "Organic - Bing" },
    { value: "Organic, DuckDuckGo", label: "Organic - DuckDuckGo" },
    { value: "Organic, YouTube", label: "Organic - YouTube" },
    { value: "Social (General)", label: "Social (General)" },
    { value: "Social, Instagram", label: "Social - Instagram" },
    { value: "Social, Facebook", label: "Social - Facebook" },
    { value: "Social, LinkedIn", label: "Social - LinkedIn" },
    { value: "Social, X, Twitter", label: "Social - X (Twitter)" },
    { value: "Social, Pinterest", label: "Social - Pinterest" },
    { value: "Referral", label: "Referral" },
    { value: "Chatbots (General)", label: "Chatbots (General)" },
    { value: "Chatbots, Meta AI", label: "Chatbots - Meta AI" },
    { value: "Chatbots, Perplexity AI", label: "Chatbots - Perplexity AI" },
    { value: "Chatbots, ChatGPT", label: "Chatbots - ChatGPT" },
    { value: "Chatbots, Claude AI", label: "Chatbots - Claude AI" },
    { value: "Chatbots, Mistral AI", label: "Chatbots - Mistral AI" },
    { value: "Chatbots, Microsoft Copilot", label: "Chatbots - Copilot" },
    { value: "Chatbots, Gemini", label: "Chatbots - Gemini" },
    { value: "Chatbots, Groq", label: "Chatbots - Groq" },
    { value: "Messengers (General)", label: "Messengers (General)" },
    { value: "Messengers, WhatsApp", label: "Messengers - WhatsApp" },
    { value: "Messengers, WeChat", label: "Messengers - WeChat" },
    { value: "Messengers, Telegram", label: "Messengers - Telegram" },
    { value: "Messengers, Viber", label: "Messengers - Viber" }
];

export const TIME_ON_PAGE_OPTS = [
    { value: "5 seconds", label: "5 seconds" },
    { value: "30 seconds", label: "30 seconds" },
    { value: "1 minute", label: "1 minute" },
    { value: "2 minutes", label: "2 minutes" },
    { value: "3 minutes", label: "3 minutes" },
    { value: "4 minutes", label: "4 minutes" },
    { value: "5 minutes", label: "5 minutes" }
];

const LEGACY_IANA_TIMEZONE_ALIASES: Record<string, string> = {
    'Europe/Kiev': 'Europe/Kyiv',
};

/**
 * Aktueller GMT-Versatz einer IANA-Zone, auf halbe Stunden gerundet.
 *
 * 🔴 Die halbe Stunde ist keine Kosmetik: `delivery_pacing.py` lehnt jeden
 * anderen Wert ab („GMT/UTC offsets must use valid 30-minute increments").
 * Die drei Viertelstunden-Zonen der Welt (Nepal +05:45, Eucla +08:45,
 * Chatham +12:45) sind damit nicht abbildbar, solange das Backend das nicht
 * kennt — und ein Backend-Fix muesste auf BEIDE Ausliefer-Maschinen.
 */
export const offsetForIanaZone = (zone: string, at: Date = new Date()): string => {
    try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'longOffset' })
            .formatToParts(at);
        const name = parts.find((p) => p.type === 'timeZoneName')?.value || '';
        const match = name.match(/^GMT([+-])(\d{1,2})(?::(\d{2}))?$/);
        if (!match) return 'GMT+00:00';
        const sign = match[1];
        const hours = Number(match[2]);
        const minutes = Number(match[3] || '0') >= 15 ? 30 : 0;
        return `GMT${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    } catch {
        return 'GMT+00:00';
    }
};

/**
 * Nur feste GMT-Versaetze, alle davon — ausdrueckliche Ansage vom 2026-08-17.
 *
 * Bereich −12:00 bis +14:00 in halben Stunden: das sind alle Versaetze, die auf
 * der Erde real vorkommen. Frueher standen hier zusaetzlich ~430 IANA-Namen
 * (`Europe/Andorra` …) und der Bereich reichte bis −14:00 — Versaetze, die es
 * nirgends gibt.
 *
 * ⚠️ Preis dieser Umstellung: ein fester Versatz kennt **keine Sommerzeit**.
 * Eine Kampagne mit „GMT+01:00" liefert von Ende Maerz bis Ende Oktober eine
 * Stunde neben der Ortszeit in Berlin. Der Hilfetext am Feld sagt das jetzt.
 */
export const generateTimezones = () => {
    const offsets: { value: string; label: string }[] = [];
    for (let halfHours = -24; halfHours <= 28; halfHours++) {
        const totalMinutes = halfHours * 30;
        const sign = totalMinutes >= 0 ? '+' : '-';
        const absoluteMinutes = Math.abs(totalMinutes);
        const hours = Math.floor(absoluteMinutes / 60);
        const minutes = absoluteMinutes % 60;
        const value = `GMT${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        offsets.push({ value, label: value });
    }
    return offsets;
};


const COUNTRY_TIMEZONE_MAP: Record<string, string> = {
    AD: 'Europe/Andorra', AE: 'Asia/Dubai', AF: 'Asia/Kabul', AG: 'America/Antigua',
    AL: 'Europe/Tirane', AM: 'Asia/Yerevan', AO: 'Africa/Luanda', AQ: 'Antarctica/McMurdo',
    AR: 'America/Argentina/Buenos_Aires', AT: 'Europe/Vienna', AU: 'Australia/Sydney', AW: 'America/Aruba',
    AZ: 'Asia/Baku', BA: 'Europe/Sarajevo', BB: 'America/Barbados', BD: 'Asia/Dhaka',
    BE: 'Europe/Brussels', BF: 'Africa/Ouagadougou', BG: 'Europe/Sofia', BH: 'Asia/Bahrain',
    BJ: 'Africa/Porto-Novo', BM: 'Atlantic/Bermuda', BN: 'Asia/Brunei', BO: 'America/La_Paz',
    BQ: 'America/Kralendijk', BR: 'America/Sao_Paulo', BS: 'America/Nassau', BT: 'Asia/Thimphu',
    BW: 'Africa/Gaborone', BY: 'Europe/Minsk', BZ: 'America/Belize', CA: 'America/Toronto',
    CD: 'Africa/Kinshasa', CG: 'Africa/Brazzaville', CH: 'Europe/Zurich', CI: 'Africa/Abidjan',
    CL: 'America/Santiago', CM: 'Africa/Douala', CN: 'Asia/Shanghai', CO: 'America/Bogota',
    CR: 'America/Costa_Rica', CU: 'America/Havana', CV: 'Atlantic/Cape_Verde', CW: 'America/Curacao',
    CY: 'Asia/Nicosia', CZ: 'Europe/Prague', DE: 'Europe/Berlin', DJ: 'Africa/Djibouti',
    DK: 'Europe/Copenhagen', DO: 'America/Santo_Domingo', DZ: 'Africa/Algiers', EC: 'America/Guayaquil',
    EE: 'Europe/Tallinn', EG: 'Africa/Cairo', ES: 'Europe/Madrid', ET: 'Africa/Addis_Ababa',
    FI: 'Europe/Helsinki', FJ: 'Pacific/Fiji', FO: 'Atlantic/Faroe', FR: 'Europe/Paris',
    GA: 'Africa/Libreville', GB: 'Europe/London', GD: 'America/Grenada', GE: 'Asia/Tbilisi',
    GF: 'America/Cayenne', GG: 'Europe/Guernsey', GH: 'Africa/Accra', GL: 'America/Nuuk',
    GM: 'Africa/Banjul', GP: 'America/Guadeloupe', GQ: 'Africa/Malabo', GR: 'Europe/Athens',
    GT: 'America/Guatemala', GU: 'Pacific/Guam', GY: 'America/Guyana', HK: 'Asia/Hong_Kong',
    HN: 'America/Tegucigalpa', HR: 'Europe/Zagreb', HT: 'America/Port-au-Prince', HU: 'Europe/Budapest',
    ID: 'Asia/Jakarta', IE: 'Europe/Dublin', IL: 'Asia/Jerusalem', IN: 'Asia/Kolkata',
    IQ: 'Asia/Baghdad', IS: 'Atlantic/Reykjavik', IT: 'Europe/Rome', JE: 'Europe/Jersey',
    JM: 'America/Jamaica', JO: 'Asia/Amman', JP: 'Asia/Tokyo', KE: 'Africa/Nairobi',
    KG: 'Asia/Bishkek', KH: 'Asia/Phnom_Penh', KM: 'Indian/Comoro', KN: 'America/St_Kitts',
    KR: 'Asia/Seoul', KW: 'Asia/Kuwait', KY: 'America/Cayman', KZ: 'Asia/Almaty',
    LA: 'Asia/Vientiane', LB: 'Asia/Beirut', LC: 'America/St_Lucia', LI: 'Europe/Vaduz',
    LK: 'Asia/Colombo', LR: 'Africa/Monrovia', LS: 'Africa/Maseru', LT: 'Europe/Vilnius',
    LU: 'Europe/Luxembourg', LV: 'Europe/Riga', LY: 'Africa/Tripoli', MA: 'Africa/Casablanca',
    MC: 'Europe/Monaco', MD: 'Europe/Chisinau', ME: 'Europe/Podgorica', MG: 'Indian/Antananarivo',
    MK: 'Europe/Skopje', ML: 'Africa/Bamako', MM: 'Asia/Yangon', MN: 'Asia/Ulaanbaatar',
    MO: 'Asia/Macau', MP: 'Pacific/Saipan', MQ: 'America/Martinique', MR: 'Africa/Nouakchott',
    MT: 'Europe/Malta', MU: 'Indian/Mauritius', MV: 'Indian/Maldives', MX: 'America/Mexico_City',
    MY: 'Asia/Kuala_Lumpur', MZ: 'Africa/Maputo', NA: 'Africa/Windhoek', NC: 'Pacific/Noumea',
    NE: 'Africa/Niamey', NG: 'Africa/Lagos', NI: 'America/Managua', NL: 'Europe/Amsterdam',
    NO: 'Europe/Oslo', NP: 'Asia/Kathmandu', NZ: 'Pacific/Auckland', OM: 'Asia/Muscat',
    PA: 'America/Panama', PE: 'America/Lima', PF: 'Pacific/Tahiti', PG: 'Pacific/Port_Moresby',
    PH: 'Asia/Manila', PK: 'Asia/Karachi', PL: 'Europe/Warsaw', PR: 'America/Puerto_Rico',
    PS: 'Asia/Gaza', PT: 'Europe/Lisbon', PY: 'America/Asuncion', QA: 'Asia/Qatar',
    RE: 'Indian/Reunion', RO: 'Europe/Bucharest', RS: 'Europe/Belgrade', RU: 'Europe/Moscow',
    RW: 'Africa/Kigali', SA: 'Asia/Riyadh', SE: 'Europe/Stockholm', SG: 'Asia/Singapore',
    SI: 'Europe/Ljubljana', SK: 'Europe/Bratislava', SL: 'Africa/Freetown', SM: 'Europe/San_Marino',
    SN: 'Africa/Dakar', SO: 'Africa/Mogadishu', SR: 'America/Paramaribo', SV: 'America/El_Salvador',
    SX: 'America/Lower_Princes', SY: 'Asia/Damascus', SZ: 'Africa/Mbabane', TG: 'Africa/Lome',
    TH: 'Asia/Bangkok', TJ: 'Asia/Dushanbe', TL: 'Asia/Dili', TN: 'Africa/Tunis',
    TR: 'Europe/Istanbul', TT: 'America/Port_of_Spain', TW: 'Asia/Taipei', TZ: 'Africa/Dar_es_Salaam',
    UA: 'Europe/Kyiv', UG: 'Africa/Kampala', US: 'America/New_York', UY: 'America/Montevideo',
    UZ: 'Asia/Samarkand', VC: 'America/St_Vincent', VE: 'America/Caracas', VI: 'America/St_Thomas',
    VN: 'Asia/Ho_Chi_Minh', XK: 'Europe/Belgrade', YE: 'Asia/Aden', YT: 'Indian/Mayotte',
    ZA: 'Africa/Johannesburg', ZM: 'Africa/Lusaka', ZW: 'Africa/Harare',
};

/**
 * Jeden gespeicherten Wert auf einen der angebotenen GMT-Versaetze bringen.
 *
 * Drei Herkuenfte muessen hier ankommen, sonst zeigt das Feld einen Wert, den
 * die Liste nicht mehr enthaelt: alte Kurzformen (`GMT+5:30`), **IANA-Namen aus
 * Bestandskampagnen** (`Europe/Andorra` — bis heute die Vorgabe) und `UTC`.
 */
export const normalizeTimezoneValue = (value?: string): string => {
    const raw = (value || '').trim();
    if (!raw || raw.toUpperCase() === 'UTC' || raw.toUpperCase() === 'GMT') return 'GMT+00:00';

    const offset = raw.match(/^(?:GMT|UTC)([+-])(\d{1,2})(?::?(\d{2}))?$/i);
    if (offset) {
        const hours = Number(offset[2]);
        // Viertelstunden-Zonen kann die Auslieferung nicht — auf die halbe Stunde.
        const minutes = Number(offset[3] || '0') >= 15 ? 30 : 0;
        if (hours > 14) return 'GMT+00:00';
        return `GMT${offset[1]}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }

    // Alles Uebrige als IANA-Zone lesen und in ihren heutigen Versatz uebersetzen.
    const canonical = LEGACY_IANA_TIMEZONE_ALIASES[raw] || raw;
    return offsetForIanaZone(canonical);
};

export const TIMEZONES = generateTimezones();

/** Vorgabe aus dem staerksten Zielland — jetzt ebenfalls als GMT-Versatz. */
export type Continent = 'Europe' | 'Americas' | 'Asia' | 'Africa' | 'Oceania';

/**
 * Kontinent je Land — Grundlage fuer das Stoebern in Schritt 3.
 *
 * Abgeleitet aus dem IANA-Praefix in `COUNTRY_TIMEZONE_MAP` (`Europe/…`,
 * `Africa/…`, `Asia/…`, `America/…`), das fuer **alle 195** Laender vorliegt.
 * Damit gibt es keine zweite Laenderliste, die auseinanderlaufen kann.
 *
 * 19 Laender tragen ein Praefix, das kein Kontinent ist (`Atlantic/`,
 * `Indian/`, `Pacific/`, `Australia/`, `Antarctica/`) — die stehen unten
 * einzeln. Island unter `Atlantic/Reykjavik` waere sonst kontinentlos,
 * Kap Verde laege neben Island statt bei Afrika.
 */
const CONTINENT_EXCEPTIONS: Record<string, Continent> = {
    AQ: 'Oceania',    // Antarktis — eigener Erdteil, aber keine eigene Gruppe wert
    AU: 'Oceania', FJ: 'Oceania', GU: 'Oceania', MP: 'Oceania', NC: 'Oceania',
    NZ: 'Oceania', PF: 'Oceania', PG: 'Oceania',
    BM: 'Americas',
    CV: 'Africa', KM: 'Africa', MG: 'Africa', MU: 'Africa', RE: 'Africa', YT: 'Africa',
    FO: 'Europe', IS: 'Europe',
    MV: 'Asia',
};

const CONTINENT_BY_IANA_PREFIX: Record<string, Continent> = {
    Europe: 'Europe', Africa: 'Africa', Asia: 'Asia', America: 'Americas',
};

export const continentForCountry = (countryCode: string): Continent => {
    const code = (countryCode || '').toUpperCase();
    const exception = CONTINENT_EXCEPTIONS[code];
    if (exception) return exception;
    const prefix = (COUNTRY_TIMEZONE_MAP[code] || '').split('/')[0];
    return CONTINENT_BY_IANA_PREFIX[prefix] || 'Europe';
};

/** Reihenfolge der Gruppen im Stoeber-Feld; Europa zuerst, weil dort das Geschaeft liegt. */
export const CONTINENT_ORDER: Continent[] = ['Europe', 'Americas', 'Asia', 'Africa', 'Oceania'];

export const COUNTRIES_BY_CONTINENT: Record<Continent, { code: string; name: string }[]> =
    CONTINENT_ORDER.reduce((acc, continent) => {
        acc[continent] = COUNTRIES_LIST
            .filter((c) => continentForCountry(c.code) === continent)
            .sort((a, b) => a.name.localeCompare(b.name));
        return acc;
    }, {} as Record<Continent, { code: string; name: string }[]>);

export const timezoneForCountry = (countryCode?: string): string => {
    const zone = COUNTRY_TIMEZONE_MAP[(countryCode || '').toUpperCase()];
    return zone ? offsetForIanaZone(zone) : 'GMT+00:00';
};
